import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  fullWidth = true,
  className = '',
  ...props
}, ref) => {
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-96" data-mp="1x8xdqvxhzazd">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-97" data-mp="zkx58ehytcip">
            {label}
          </label>}
        <input ref={ref} className={`
            block w-full rounded-md border-gray-300 shadow-sm 
            focus:border-blue-500 focus:ring-blue-500 sm:text-sm
            disabled:bg-gray-50 disabled:text-gray-500
            border p-2
            ${error ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-98" data-mp="14kt6i5za2puk" />
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-99" data-mp="2oxs8mtsgzy5k">{error}</p>}
      </div>;
});
Input.displayName = 'Input';